import React from 'react';
import {Page, Button, Spinner} from '../../components';
import {Query} from '../../utils';
import List from './list.js';
import classNames from 'classnames';
import trash from './images/trash-3.svg';
import sprintf  from 'yow/sprintf'; 
import './index.sass';
 
export default class extends React.Component {


    constructor(props) {
        super(props);
        this.state = {};
        this.query = new Query();
        this.state.rows = undefined;
        this.state.loading = true;
        this.state.columns = [];
        this.state.selection = {};

        let addColumn = (column) => {
            if (typeof column == 'function')
                column = column();

            this.state.columns.push(column);
        }

        addColumn(() => {

            let format = (date) =>  {
                if (date == null)
                    return '';
                date = new Date(date);
                return sprintf('%04d-%02d-%02d %02d:%02d', date.getFullYear(), date.getMonth()+1, date.getDate(), date.getHours(), date.getMinutes());
            }
            return ({
                name: 'Datum',
                text: (row) => format(row.timestamp),
                value: (row) => row.timestamp,
                style: {width:'12em'}

            });
        });


        addColumn({
            name: 'Meddelande',
            value: (row) => row == undefined ? '-' : row.message,
            text: (row) => row.message

        });




    }





    async fetch() {
        try {
            let rows = await this.query.fetch('SELECT * FROM log ORDER BY timestamp DESC LIMIT 100');
            this.setState({rows:rows, selection: {}, loading:false});

    
        }
        catch(error) {
            console.log(error.message);

        }
    }

    async componentDidMount() {
        await this.fetch();
    }




    renderTable() {


        let onSelectionChange = (rows) => {
        };

        return (
            <div>
                <h4>Loggen</h4>
                <List 
                    selection={{1:this.state.rows[1]}} 
                    rows={this.state.rows} 
                    columns={this.state.columns} 
                    border
                    sortBy={0} 
                    sortOrder={'descending'} 
                    style={{height:'20rem'}}
                    filter=''
                    selectionStyle='single'>
                </List>
            </div>
        );


    }



    renderSpinner() {
        let style = {};
        style.marginLeft = 'auto';
        style.marginRight = 'auto';
        style.display = 'flex';
        style.alignItems = 'center';

        return (
            <Spinner style={style} animation="grow" />
        );
    }

    renderText() {
        return (
            <p>Detta är loggen med alla 100 senaste felmeddelande.</p>
        );
    }

    render() {


        if (this.state.loading) {
            return (
                <Page>
                    {this.renderSpinner()}
                 </Page>
            );
    
        }

        if (this.state.rows) {
            return (
                <Page>
                    {this.renderText()}
                    {this.renderTable()}
                    <Button link={-1} className='mt-2'>
                        Tillbaka
                    </Button>
                </Page>

            );
        }

        return (
            <Page>
                <Button link={-1}>
                    Tillbaka
                </Button>
            </Page>
        );


    }
}



